module.exports = __webpack_public_path__ + "static/feature-05-87a69bc088f2f04b5749a50ac9ea40ad.png";